import { render } from "./QOptionGroup.vue?vue&type=template&id=1302c6b8"
import script from "./QOptionGroup.vue?vue&type=script&lang=ts"
export * from "./QOptionGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QField from 'quasar/src/components/field/QField.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QOptionGroup});
